// utils/localTag.ts
export interface ITag {
  id: string;
  tagName: string;
}

const STORAGE_KEY = 'tags';

export const getTagsLS = (): ITag[] => {
  const data = localStorage.getItem(STORAGE_KEY);
  return data ? JSON.parse(data) : [];
};

export const saveTagsLS = (tags: ITag[]) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(tags));
};

export const addTagLS = (tag: ITag) => {
  const tags = getTagsLS();
  tags.push(tag);
  saveTagsLS(tags);
};

export const updateTagLS = (id: string, newName: string) => {
  const tags = getTagsLS().map((t) =>
    t.id === id ? { ...t, tagName: newName } : t
  );
  saveTagsLS(tags);
};

export const deleteTagLS = (id: string) => {
  const tags = getTagsLS().filter((t) => t.id !== id);
  saveTagsLS(tags);
};
